import React, { createContext, useState, useContext } from 'react';
import { PAUL_DOMAIN, PROTOCOL } from 'constants';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
export const GenieContext = createContext({});

import { getAuthorizationHeader } from 'services/authorization_token';
import { useRequest } from 'components/wizard/context/request/hook';
import { useCurrentBrand } from 'contexts/current_brand/use_current_brand';
import axios from 'axios';
import { usePaul } from 'components/paul/provider';
export const useGenie = () => {
  return useContext(GenieContext);
};

const GenieProvider = ({ children, onSuccess }) => {
  const { startGenie, stopGenie } = usePaul();
  const [isGenieModalOpen, setIsGenieModalOpen] = useState(false);
  const [isOcrModalOpen, setIsOcrModalOpen] = useState(false);
  const [step, setStep] = useState(1);
  const { request } = useRequest();
  const [smartFields, setSmartFields] = useState([]);
  const [file, setFile] = useState(null);
  const [text, setText] = useState('');
  const [willImport, setWillImport] = useState(false);
  const [askingGenie, setAskingGenie] = useState(false);
  const [error, setError] = useState(null);
  const [wordToHighlight, setWordToHighlight] = useState(null);
  const [genieProgress, setGenieProgress] = useState([]);
  const { currentBrand } = useCurrentBrand();

  const onGenieProgress = (data) => {
    console.log('@[GenieProvider] genie-progress', data);
    setGenieProgress((prev) => ({
      ...prev,
      [data.step]: data,
    }));
  };

  const sendToGenie = async () => {
    setAskingGenie(true);
    const authHeader = {
      Authorization: getAuthorizationHeader(),
    };
    let response;
    let document = null;
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('requestId', request.id);

      try {
        /*response = await axios.post(`${PROTOCOL}://${PAUL_DOMAIN}/genie/extract-fields`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            ...authHeader,
          },
        });*/
        response = await axios.post(`${PROTOCOL}://${PAUL_DOMAIN}/genie/upload/document?requestId=${request.id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-brand': currentBrand.slug,
            ...authHeader,
          },
        });
        console.log('@[GenieProvider] response', response);
        document = {
          file: response.data.file,
        };
        setStep(3);
      } catch (error) {
        console.error('Error asking genie:', error);
        setError(error);
        throw error;
      } finally {
        setAskingGenie(false);
      }
    } else {
      document = text;
      setStep(3);
      setAskingGenie(false);
    }
    startGenie(document, onGenieProgress);
  };

  const toggleGenieModal = () => {
    setIsGenieModalOpen(!isGenieModalOpen);
    stopGenie(onGenieProgress);
  };

  const toggleOcrModal = () => {
    const newIsOcrModalOpen = !isOcrModalOpen;
    setIsOcrModalOpen(newIsOcrModalOpen);
    if (newIsOcrModalOpen) {
      setWordToHighlight(null);
    }
  };

  const displayWordInOCR = (clickedWord) => {
    setIsOcrModalOpen(true);
    setWordToHighlight(clickedWord);
  };

  return (
    <GenieContext.Provider
      value={{
        step,
        setStep,
        smartFields,
        setSmartFields,
        text,
        setText,
        willImport,
        setWillImport,
        importDisabled: isNil(file) && isEmpty(text),
        sendToGenie,
        file,
        setFile,
        askingGenie,
        isGenieModalOpen,
        toggleGenieModal,
        isOcrModalOpen,
        toggleOcrModal,
        displayWordInOCR,
        wordToHighlight,
        genieProgress,
      }}
    >
      {children}
    </GenieContext.Provider>
  );
};

export default GenieProvider;
